module.exports = __webpack_public_path__ + "img/master.50c9f88b.svg";